import { render, staticRenderFns } from "./app-dev-tool.vue?vue&type=template&id=afe9da64&"
import script from "./app-dev-tool.vue?vue&type=script&lang=ts&"
export * from "./app-dev-tool.vue?vue&type=script&lang=ts&"
import style0 from "./app-dev-tool.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports